<template>
  <h3>Testimonials</h3>
  
          <div class="container mt-5 mb-5">
            <div class="row g-2">
                <div class="col-md-6 col-6 col-sm-12">
                    <div class="card p-3 text-center px-4">
                        <div class="user-image"> <img src="@/assets/pics/Godwin.jpeg" width="250px" style="border-radius: 50%;"> </div>
                        <div class="user-content">
                            <h4 class="mb-0">Godwin Dzvapatsva</h4> <h5>Head of Curriculum</h5>
                            <p>I see a lot of potential in Akha as a coding student. He loves participating when he knows the answer. I think Akha is a quick learner, so he will improve these skills quickly through focused studying.</p>
                        </div>
                 
       <a href="https://www.linkedin.com/in/akha-kombora-965959226/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BYhKLhOxQSUG%2FSk87RPnGpw%3D%3D" class="btn"  ><i class="fas fa-envelope-open-text"></i></a>   </div>
                </div>
                <div class="col-md-6 col-6-sm-12">
                    <div class="card p-3 text-center px-4">
                        <div class="user-image"> <img src="@/assets/pics/jason.jpg" width="250px" style="border-radius: 50%;"> </div>
                        <div class="user-content">
                            <h4 class="mb-0">Jason Wandrag</h4> <h5>Lecturer</h5>
                            <p>Akha is always a pleasure to work with. He never hesitates to ask when he has a question which helps him gain a lot pf knowledge</p>
                        </div>
                
       <a href="https://www.linkedin.com/in/akha-kombora-965959226/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BYhKLhOxQSUG%2FSk87RPnGpw%3D%3D" class="btn"  ><i class="fas fa-envelope-open-text"></i></a>   </div>
                </div>
                <div class="col-md-6 col-6-sm-12">
                  <div class="card p-3 text-center px-4">
                      <div class="user-image"> <img src="@/assets/pics/Jude.jpg" width="250px" style="border-radius: 50%;"> </div>
                      <div class="user-content">
                          <h4 class="mb-0">Jude Julius</h4> <h5>Colleague</h5>
                          <p>Akha is a very futuristic peron, he knows what he wants and is a go getter</p>
                      </div>
            <a href="https://www.linkedin.com/in/akha-kombora-965959226/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BYhKLhOxQSUG%2FSk87RPnGpw%3D%3D" class="btn"  ><i class="fas fa-envelope-open-text"></i></a>   </div>
             </div>
                <div class="col-md-6 col-12">
                    <div class="card p-3 text-center px-4">      
                         <div class="user-image"> <img src="@/assets/pics/Kagiso.jpg" width="250px" style="border-radius: 50%;"> </div>
                    <div class="user-content">
                        <h4 class="mb-0">Kagiso Mphayi</h4> <h5>Colleague</h5>
                        <p>Akha is a bright student with a bright future ahead of him. He has immense potential and a great work ethic, which is why I highly reccomend him</p>
                    </div>
             
       <a href="https://www.linkedin.com/in/akha-kombora-965959226/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BYhKLhOxQSUG%2FSk87RPnGpw%3D%3D" class="btn"  ><i class="fas fa-envelope-open-text"></i></a>   </div>
            </div>
        </div>
        </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.testimonials .section-header {
  margin-bottom: 40px;
}
.testimonials .testimonials-carousel, .testimonials .testimonials-slider {
  overflow: hidden;
}
.testimonials .testimonial-item {
  text-align: center;
}
.testimonials .testimonial-item .testimonial-img {
  width: 120px;
  border-radius: 50%;
  border: 4px solid #fff;
  margin: 0 auto;
}
.testimonials .testimonial-item h3 {
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0 5px 0;
  color: #111;
}
.testimonials .testimonial-item h4 {
  font-size: 14px;
  color: #999;
  margin: 0 0 15px 0;
}
.testimonials .testimonial-item .quote-icon-left, .testimonials .testimonial-item .quote-icon-right {
  color: #90c8fc;
  font-size: 26px;
}
.testimonials .testimonial-item .quote-icon-left {
  display: inline-block;
  left: -5px;
  position: relative;
}
.testimonials .testimonial-item .quote-icon-right {
  display: inline-block;
  right: -5px;
  position: relative;
  top: 10px;
}
.testimonials .testimonial-item p {
  font-style: italic;
  margin: 0 auto 15px auto;
}
.testimonials .swiper-pagination {
  margin-top: 20px;
  position: relative;
}
.testimonials .swiper-pagination .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background-color: #fff;
  opacity: 1;
  border: 1px solid #0563bb;
}
.testimonials .swiper-pagination .swiper-pagination-bullet-active {
  background-color: #0563bb;
}
@media (min-width: 992px) {
  .testimonials .testimonial-item p {
    width: 80%;
  }
}
@media (min-width: 992px) {
  .col {
    width: 80%;
  }
}
</style>